export default {
  ENABLED: ['1', 'true'].includes(process.env.SSR_CACHE_ENABLED ?? ''),
  TTL: process.env.SSR_CACHE_TTL ? parseInt(process.env.SSR_CACHE_TTL) : 90,
  PATH: process.env.SSR_CACHE_PATH ?? './storage/cache',
}
